// ========== 新表情系统：109个微信风格 PNG，格式 [表情名] ==========
const newEmojiNames = [
	'微笑', '撇嘴', '色', '发呆', '得意', '流泪', '害羞', '闭嘴', '睡', '大哭',
	'尴尬', '发怒', '调皮', '呲牙', '惊讶', '难过', '囧', '抓狂', '吐', '偷笑',
	'愉快', '白眼', '傲慢', '困', '惊恐', '憨笑', '悠闲', '咒骂', '疑问', '嘘',
	'晕', '衰', '骷髅', '敲打', '再见', '擦汗', '抠鼻', '鼓掌', '坏笑', '右哼哼',
	'鄙视', '委屈', '快哭了', '阴险', '亲亲', '可怜', '笑脸', '生病', '脸红', '破涕为笑',
	'恐惧', '失望', '无语', '嘿哈', '捂脸', '奸笑', '机智', '皱眉', '耶', '吃瓜',
	'加油', '汗', '天啊', 'Emm', '社会社会', '旺财', '好的', '打脸', '哇', '翻白眼',
	'666', '让我看看', '叹气', '苦涩', '裂开', '嘴唇', '爱心', '心碎', '拥抱', '强',
	'弱', '握手', '胜利', '抱拳', '勾引', '拳头', 'OK', '合十', '啤酒', '咖啡',
	'蛋糕', '玫瑰', '凋谢', '菜刀', '炸弹', '便便', '月亮', '太阳', '庆祝', '礼物',
	'红包', '發', '福', '烟花', '爆竹', '猪头', '跳跳', '发抖', '转圈'
]

const emojiList = newEmojiNames.map((name, idx) => {
	const num = String(idx + 1).padStart(2, '0')
	return {
		key: `[${name}]`,
		url: require(`@/assets/emoji-wx/emoji_${num}.png`)
	}
})

const newEmojiMap = {}
emojiList.forEach(item => { newEmojiMap[item.key] = item.url })
const newRegex = /\[[^\[\]]{1,6}\]/g

// ========== 旧表情系统：57个 GIF，格式 #表情名;（向后兼容） ==========
const oldEmoTextList = ['憨笑', '媚眼', '开心', '坏笑', '可怜', '爱心', '笑哭', '拍手', '惊喜', '打气',
	'大哭', '流泪', '饥饿', '难受', '健身', '示爱', '色色', '眨眼', '暴怒', '惊恐',
	'思考', '头晕', '大吐', '酷笑', '翻滚', '享受', '鼻涕', '快乐', '雀跃', '微笑',
	'贪婪', '红心', '粉心', '星星', '大火', '眼睛', '音符', "叹号", "问号", "绿叶",
	"燃烧", "喇叭", "警告", "信封", "房子", "礼物", "点赞", "举手", "喝彩", "点头",
	"摇头", "偷瞄", "庆祝", "疾跑", "打滚", "惊吓", "起跳"
];
const oldRegex = /\#[\u4E00-\u9FA5]{1,3}\;/gi

let transform = (content, extClass) => {
	// 第一遍：匹配新格式 [表情名]
	let result = content.replace(newRegex, (match) => {
		if (newEmojiMap[match]) {
			return `<img src="${newEmojiMap[match]}" class="${extClass}" />`
		}
		return match
	})
	// 第二遍：匹配旧格式 #表情名;（向后兼容）
	result = result.replace(oldRegex, (match) => {
		let word = match.replace(/\#|\;/gi, '')
		let idx = oldEmoTextList.indexOf(word)
		if (idx === -1) return match
		let url = require(`@/assets/emoji/${idx}.gif`)
		return `<img src="${url}" class="${extClass}" />`
	})
	return result
}

let textToUrl = (emoKey) => {
	return newEmojiMap[emoKey] || ''
}

// 旧接口保留
let textToImg = (emoText, extClass) => {
	// 新格式
	if (newEmojiMap[emoText]) {
		return `<img src="${newEmojiMap[emoText]}" class="${extClass}" />`
	}
	// 旧格式
	let word = emoText.replace(/\#|\;/gi, '')
	let idx = oldEmoTextList.indexOf(word)
	if (idx === -1) return emoText
	let url = require(`@/assets/emoji/${idx}.gif`)
	return `<img src="${url}" class="${extClass}" />`
}

export default {
	emojiList,
	emoTextList: oldEmoTextList,
	transform,
	textToImg,
	textToUrl
}
